import api from 'api/api'

import { toast } from "react-toastify"
import { API_URL } from 'constants/index'

export const UPDATE_SERIE_PRODUCT = "[SERIES PRODUCT] UPDATE SERIE PRODUCT"
export const GET_SERIES_RELATED = "[SERIES PRODUCT] GET SERIES RELATED"

export function quitSerieProduct(form) {
  const request = api.post(`/quitarrelacionserie`, form)
  return (dispatch) => {
    dispatch({ type: UPDATE_SERIE_PRODUCT, payload: { loading: true, updated: false } })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        toast.success(response.data.message)
        dispatch({ type: UPDATE_SERIE_PRODUCT, payload: { loading: false, updated: true } })
        return setTimeout(() => {
          dispatch({ type: UPDATE_SERIE_PRODUCT, payload: { loading: false, updated: false } })
        }, 50)
      } else {
        toast.error(response.data.message)
        return dispatch({ type: UPDATE_SERIE_PRODUCT, payload: { loading: false, updated: false } })
      }
    }).catch((error) => {
      console.log(UPDATE_SERIE_PRODUCT, error)
      return dispatch({ type: UPDATE_SERIE_PRODUCT, payload: { loading: false, updated: false } })
    })
  }
}

export function getSeriesRelated(relatedName, relatedId, useLoading = true) {
  const request = api.get(`/seriesrelacionado/${relatedName}/${relatedId}`)
  return (dispatch) => {
    if (useLoading) {
      dispatch({ type: GET_SERIES_RELATED, payload: { loading: true } })
    }
    request.then((response) => {
      dispatch({ type: GET_SERIES_RELATED, payload: { loading: false, data: response.data.detalles } })
      setTimeout(() => {
        dispatch({ type: GET_SERIES_RELATED, payload: { loading: false, data: null } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: GET_SERIES_RELATED, payload: { loading: false, data: null } })
      console.log(GET_SERIES_RELATED, error)
    })
  }
}